module.exports = __webpack_public_path__ + "messageList_up.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/chatMessage/img/messageList_up.png
// module id = 802
// module chunks = 9